import React, { useEffect } from "react";
import { AppLogo } from "../svg/Index";
import Breadcrumbs from "./Breadcrumbs";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, matchPath, useLocation } from "react-router-dom";
import routes from "../../utils/constants/routes";
import { appConfig } from "../../utils/configs";
import { useGlobalState } from "../../contexts/GlobalContext";
import { IconArrowRight } from "../icon/icon-right-arrow";
export type IHeaderProps = {
  onMenuClick: () => void;
  isAuthenticated: boolean;
  setIsShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
};

const Header: React.FC<IHeaderProps> = (props) => {
  const { onMenuClick, isAuthenticated, setIsShowMenu } = props;
  const location = useLocation();
  const { globalState } = useGlobalState();
  const userStatus = globalState?.user?.user_metadata?.user_status ?? 0;
  const hideLogoPaths = [
    routes.Events,
    routes.SURVEY_ANSWER,
    routes.SURVEY_ANSWER_CONFIRM,
    routes.SURVEY_ANSWER_FINISH,
    routes.WITHDRAWALFINISH,
  ];

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= 776;
      if (location.pathname === "/user" && isMobile && userStatus == 2) {
        setIsShowMenu(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [location.pathname, setIsShowMenu, globalState.user]);

  const handleLink = (link: string) => {
    if (userStatus == 1 || userStatus == 3) return;
    window.location.href = link;
  };

  return (
    <>
      <header id="header">
        <nav className="navbar">
          <div className="head-groups">
            <div className="head-item">
              <>
                {isAuthenticated &&
                  !hideLogoPaths.some((path) =>
                    matchPath(path, location.pathname)
                  ) && (
                    <i onClick={onMenuClick} className="icon-menu-container">
                      <MenuIcon className="icon-menu" />
                    </i>
                  )}
              </>
              <div
                className="head-logo"
                style={{
                  cursor: `${
                    userStatus == 1 || userStatus == 3 ? "unset" : "pointer"
                  }`,
                }}
                onClick={() =>
                  handleLink(`${appConfig.SPA_EVENT_WEB}/marketing/`)
                }
              >
                <AppLogo />
              </div>
              {!hideLogoPaths.some((path) =>
                matchPath(path, location.pathname)
              ) && (
                <div className="d-flex gap-responsive">
                  <div
                    className="head-item__text"
                    style={{
                      cursor: `${
                        userStatus == 1 || userStatus == 3 ? "unset" : "pointer"
                      }`,
                    }}
                    onClick={() =>
                      handleLink(`${appConfig.SPA_EVENT_WEB}/marketing/`)
                    }
                  >
                    マーケティング
                    <IconArrowRight
                      fill="#007383"
                    />
                  </div>
                  <div
                    className="head-item__text"
                    style={{
                      cursor: `${
                        userStatus == 1 || userStatus == 3 ? "unset" : "pointer"
                      }`,
                    }}
                    onClick={() =>
                      handleLink(`${appConfig.SPA_EVENT_WEB}/creative/`)
                    }
                  >
                    クリエイティブ
                    <IconArrowRight
                      fill="#007383"
                    />
                  </div>
                  <div
                    className="head-item__text"
                    style={{
                      cursor: `${
                        userStatus == 1 || userStatus == 3 ? "unset" : "pointer"
                      }`,
                    }}
                    onClick={() =>
                      handleLink(`https://www.kankyo-business.jp/`)
                    }
                  >
                    環境ビジネス
                    <IconArrowRight
                      fill="#007383"
                    />
                  </div>
                  {/* <div className="head-item__text">お客様情報登録・変更</div> */}
                </div>
              )}
            </div>
          </div>
        </nav>
        <Breadcrumbs />
      </header>
    </>
  );
};

export default Header;
